import React, { useMemo } from 'react';
import { CategoryBoard } from './board/CategoryBoard';

// Works for both modes: 1-to-1 (each right_item unique) and categorisation (many left_items share a right_item).
const MatchingElement = ({ config, element, progress, onComplete, onSaveData, isCompleted }) => {
  const matchConfig = config.matching || config;
  const rawPairs = matchConfig.pairs || config.pairs || [];

  const { items, zones } = useMemo(() => {
    const pairs = rawPairs.map((p, i) => ({
      id: p.id || `pair-${i}`,
      left: p.left_item || p.left || '',
      right: (p.right_item || p.right || '').trim(),
      imageUrl: p.left_image_url,
      imageAlt: p.left_image_alt,
    })).filter(p => p.left && p.right);
    const labels = [...new Set(pairs.map(p => p.right))];
    const zoneId = (label) => `cat-${labels.indexOf(label)}`;
    return {
      zones: labels.map(l => ({ id: zoneId(l), label: l })).sort(() => Math.random() - 0.5),
      items: pairs.map(p => ({ id: p.id, text: p.left, imageUrl: p.imageUrl, imageAlt: p.imageAlt, zoneId: zoneId(p.right) })).sort(() => Math.random() - 0.5),
    };
  }, [element?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!items.length) return <p className="text-sm text-slate-500" data-testid="matching-empty">This activity has not been set up yet.</p>;

  const mode = matchConfig.mode || (zones.length < items.length ? 'categorise' : 'one_to_one');
  const defaultText = {
    categorise: 'Place each scenario into the category it belongs to.',
    mixed: 'Match each item to its correct pair or category.',
    one_to_one: 'Match each item to its correct pair.',
  }[mode] || 'Match each item to its correct pair.';

  return (
    <div className="space-y-4" data-testid="matching-element" data-mode={mode}>
      <p className="text-slate-700 text-sm">{matchConfig.instructions || defaultText}</p>
      <CategoryBoard
        items={items}
        zones={zones}
        savedPlaced={progress?.element_progress?.[element?.id]?.placed}
        isCompleted={isCompleted}
        onSaveData={onSaveData}
        onComplete={onComplete}
        testPrefix="match"
      />
    </div>
  );
};

export default MatchingElement;
